module.exports = __webpack_public_path__ + "img/Elven_Arrow_02.96c8284a.png";